/**
 * @desc 通过查询参数获取费用映射信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.CostItemMappingResponseDto>>;
export function request(
  body: defs.basics.CostItemMappingRequestRpcParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/costItemMapping/getCostItemMappingInfo`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
